import Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

const osName = browser.getOSName(true);
export  const isAndroid = osName === 'android';
export  const isIOS = osName === 'ios';
